module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.config.title || 'Preview'}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\" style=\"padding:0px !important\">\r\n\r\n  <html-iframe content=\"$ctrl.content\"></html-iframe>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Close</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/iframe-preview/iframe-preview.component.html
// module id = 746
// module chunks = 0